import { render, staticRenderFns } from "./payment-marketing-channels.vue?vue&type=template&id=622a8c46&scoped=true"
import script from "./payment-marketing-channels.vue?vue&type=script&lang=ts"
export * from "./payment-marketing-channels.vue?vue&type=script&lang=ts"
import style0 from "./payment-marketing-channels.vue?vue&type=style&index=0&id=622a8c46&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622a8c46",
  null
  
)

export default component.exports